// extracted by mini-css-extract-plugin
module.exports = {"checkboxBase":"Checkbox_checkboxBase__qDHL2","disabled":"Checkbox_disabled__zfDH2","checked":"Checkbox_checked__dE5F5","focused":"Checkbox_focused__GH8QN"};